export class ProgramaVerificacionViewModel {
    public Id: number;
    public IdUsuarioEntidadAuditora: number | null;
    public IdUsuarioComunidadAutonoma: number | null;
    public IdEstadoPv: number;
    public Campania: string;
    public Periodo: string;
    public ComunidadAutonoma: string;
    public EstadoPv: string;
    public Observaciones: string;
    public FechaPresentacion: Date | null;
    public FechaAdmision: Date | null;
    public FechaDevolucion: Date | null;
    public TwDocumentacionPvCam: TwDocumentacionPvCamViewModel = new TwDocumentacionPvCamViewModel();
}

export class TwDocumentacionPvCamViewModel {
    public IdProgramaVerificacion: number;
    public Texto = '';
    public Fecha: Date | null = null;
    public CodigoStorage = '';
    //public OldCodigoStorageCollection?: string[] = [];
    public NombreArchivo = '';
    public Size: number | null = null;
    public IdUsuario: number;
    public IdDocFileSystem?: number;
}
